import React from "react";
import { Link } from "react-router-dom";

const Legal: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex flex-col gap-6 p-3 md:p-6 flex-grow max-w-2xl">
        <Link to="/" className="text-xs underline">← Retour</Link>

        <h1>Mentions légales</h1>

        <section className="flex flex-col gap-2">
          <h2 className="text-lg font-bold">1. Informations générales</h2>
          <p><strong>Dénomination sociale :</strong> Association Cinemir</p>
          <p><strong>Forme juridique :</strong> Association à but non lucratif</p>
          <div>
            <strong>Adresse du siège :</strong>
            <address className="not-italic">
              Avenue de Tourbillon 36b<br />
              1950 Sion<br />
              Suisse
            </address>
          </div>
          <p><strong>Téléphone :</strong> <a href="tel:+41787402235">+41 78 740 22 35</a></p>
          <p><strong>Site web :</strong> <a href="https://www.cinemir.ch">https://www.cinemir.ch</a></p>
          <p><strong>Secteur d'activité :</strong> Cinéma / cinéclub participatif</p>
          <p><strong>Description de l'activité :</strong> Cinemir est un cinéclub participatif organisé sous la forme d'une association à but non lucratif. L'association organise des projections de films et des activités culturelles autour du cinéma.</p>
        </section>

        <section className="flex flex-col gap-2">
          <h2 className="text-lg font-bold">2. Responsables de l'association</h2>
          <div>
            <p><strong>Président de l'association</strong></p>
            <p>Stéphane Favre</p>
            <p>Email : <a href="mailto:stephanefavre@bluemail.ch">stephanefavre@bluemail.ch</a></p>
          </div>
          <div>
            <p><strong>Trésorier</strong></p>
            <p>Maged El Sadek</p>
            <p>Email : <a href="mailto:contact@cinemir.ch">contact@cinemir.ch</a></p>
          </div>
        </section>

        <section className="flex flex-col gap-2">
          <h2 className="text-lg font-bold">3. Contact</h2>
          <p>Pour toute question concernant l'association ou ses activités, vous pouvez nous contacter via :</p>
          <p>Email : <a href="mailto:contact@cinemir.ch">contact@cinemir.ch</a></p>
          <p>Téléphone : <a href="tel:+41787402235">+41 78 740 22 35</a></p>
        </section>

        <section className="flex flex-col gap-2">
          <h2 className="text-lg font-bold">4. Hébergement du site</h2>
          <p>Le site <a href="https://www.cinemir.ch">https://www.cinemir.ch</a> est hébergé par Infomaniak.</p>
        </section>

        <section className="flex flex-col gap-2">
          <h2 className="text-lg font-bold">5. Propriété intellectuelle</h2>
          <p>L'ensemble des contenus présents sur ce site (textes, images, logos, éléments graphiques) est la propriété de l'Association Cinemir ou est utilisé avec l'autorisation de leurs propriétaires respectifs.</p>
          <p>Toute reproduction, distribution ou utilisation sans autorisation préalable est interdite.</p>
        </section>

        <section className="flex flex-col gap-2">
          <h2 className="text-lg font-bold">6. Protection des données</h2>
          <p>Les informations personnelles éventuellement collectées via le site sont utilisées uniquement dans le cadre des activités de l'association.</p>
          <p>Les données ne sont pas vendues ni transmises à des tiers, sauf lorsque cela est nécessaire pour le fonctionnement de services liés au site (par exemple les services de paiement).</p>
        </section>

        <section className="flex flex-col gap-2">
          <h2 className="text-lg font-bold">7. Paiements</h2>
          <p>Les paiements effectués sur ce site peuvent être traités via des prestataires de paiement tiers, notamment Stripe, incluant certains moyens de paiement tels que TWINT.</p>
          <p>Ces prestataires appliquent leurs propres conditions d'utilisation et politiques de confidentialité.</p>
        </section>
      </div>
    </div>
  );
};

export default Legal;
